import { render, staticRenderFns } from "./EditAddon.vue?vue&type=template&id=6d2337d3&scoped=true&"
import script from "./EditAddon.vue?vue&type=script&lang=js&"
export * from "./EditAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2337d3",
  null
  
)

export default component.exports